import { Children, isValidElement } from 'react';
import type { ReactNode } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { useFormContext } from 'framework/form';
import { getVisibility } from 'framework/utils';

const AssignmentDrawerRow = ({ children, fullWidth }: { children: ReactNode; fullWidth?: boolean }) => {
  const { data } = useFormContext();
  const fields = Children.toArray(children).filter(
    child =>
      isValidElement<{ isVisible?: boolean | ((data: any) => boolean) }>(child) &&
      getVisibility(data, child.props.isVisible),
  );

  if (!fields.length) return null;

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid key={index} size={{ xs: 12, md: fullWidth ? 12 : 4 }}>
          {field}
        </Grid>
      ))}
    </Grid>
  );
};

export default AssignmentDrawerRow;
